export const GSTR1_NILL_SECTION_TITLES: Record<string, string> = {
  '8a': 'Inter-State supplies to registered persons',
  '8b': 'Inter-State supplies to unregistered persons',
  '8c': 'Intra-State supplies to registered persons',
  '8d': 'Intra-State supplies to unregistered persons',
};

const GSTR1_NILL_AMOUNT_TYPE_SUFFIX: Record<string, string> = {
  nilrated: ' -Nil Rated',
  exempted: ' -Exempted',
  nongst: ' -Non-GST',
};

export function getGstr1NillDrilldownTitles(search: string) {
  const params = new URLSearchParams(search);
  const section = (params.get('section') ?? '').toLowerCase();
  const amountType = (params.get('amountType') ?? '').toLowerCase();
  const baseTitle =
    GSTR1_NILL_SECTION_TITLES[section] ?? 'Nil rated, Exempted and non GST outward supplies';
  const suffix = GSTR1_NILL_AMOUNT_TYPE_SUFFIX[amountType] ?? '';
  return {
    baseTitle,
    fullTitle: `${baseTitle}${suffix}`,
  };
}

/** Parent list link for nil drilldown breadcrumbs (keeps date range only). */
export function getGstr1NillRatedParentLink(search: string) {
  const params = new URLSearchParams(search);
  const parentParams = new URLSearchParams();
  const fromDate = params.get('fromDate');
  const toDate = params.get('toDate');
  if (fromDate) parentParams.set('fromDate', fromDate);
  if (toDate) parentParams.set('toDate', toDate);
  const qs = parentParams.toString();
  return `/gstr1/nillRated${qs ? `?${qs}` : ''}`;
}
